export const COMPANY_NAME_SUBTITLE_KEYWORDS: string[] = [
    'foodcourt',
    'food-court',
    'restaurant',
    'cafe',
    'coffee',
    'bar',
    'bistro',
    'bakery',
    'kitchen',
    'diner',
    'grill',
    'pub',
    'lounge'
];

export interface ISmartBusinessTitle {
    hasSmartSubtitle: boolean;
    mainTitle: string;
    subtitle: string;
}

export const getSmartBusinessTitle = (title: string): ISmartBusinessTitle => {
    const normalizedTitle = title.trim().replace(/\s+/g, ' ');
    const titleParts = normalizedTitle.split(' ');
    const subtitleKeywords = new Set(COMPANY_NAME_SUBTITLE_KEYWORDS);
    const lastWord = titleParts[titleParts.length - 1]?.toLowerCase() || '';
    const hasSmartSubtitle = titleParts.length > 1 && subtitleKeywords.has(lastWord);

    return {
        hasSmartSubtitle,
        mainTitle: hasSmartSubtitle ? titleParts.slice(0, -1).join(' ') : normalizedTitle,
        subtitle: hasSmartSubtitle ? titleParts[titleParts.length - 1] : ''
    };
};
